module.exports = "<app-my-device *ngFor=\"let dev of dataStorageService.devices; let i = index\"\n               [device]=\"dev\"\n               [i]=\"i\">\n\n</app-my-device>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/manage-my-devices/my-device-list/my-device-list.component.html
// module id = ./src/app/content/manage-my-devices/my-device-list/my-device-list.component.html
// module chunks = main